import type { Settlement } from '../map/settlement';
import type { HexMapState } from '../render/renderer';
import type { AbstractModal } from '../../modal/AbstractModal';

export function getSettlement(state: HexMapState, modal: AbstractModal): Settlement | null {
    if (!modal.settlementId) return null;
    return state.settlementsById[modal.settlementId] || null;
}
